import { OrderPaymentStatus } from '../../types/marketplace/order';
import { StoreType } from 'types/common';
import { CONNECT_STORE_DETAIL_URL, GAMEWEAR_STORE_DETAIL_URL } from './confirmItem';
import { MD_STORE_DETAIL_URL } from 'services/config';

export const revenueStatusLabel = {
  [OrderPaymentStatus.REFUNDED]: 'Refunded',
  [OrderPaymentStatus.INCOMPLETE]: 'Incomplete',
  [OrderPaymentStatus.COMPLETED]: 'Completed',
  [OrderPaymentStatus.ERROR]: 'Error',
};

export enum SectionType {
  'ROW' = 'row',
  'TAIL' = 'tail',
  'HEADER' = 'header',
}

export enum SectionTextColor {
  'DEFAULT' = 'textPrimary',
  'SECOND' = 'textSecondary',
  'ERROR' = 'error',
}

export enum PeriodCheckType {
  BEFORE = 'BEFORE',
  WITHIN = 'WITHIN',
}

export const MONTHLY_LIST: (
  | 'jan'
  | 'feb'
  | 'mar'
  | 'apr'
  | 'may'
  | 'jun'
  | 'jul'
  | 'aug'
  | 'sep'
  | 'oct'
  | 'nov'
  | 'dec'
)[] = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

export const MONTHLY_PAYOUT_START_YEAR = {
  ITEM_SALES: '2022',
  REFERRAL: '2025',
}
export const WITHHOLDING_TAX_START_DATE = '2022-06';

export const STORE_DETAIL_URLS: { [key in StoreType]: string } = {
  [StoreType.CONNECT]: CONNECT_STORE_DETAIL_URL,
  [StoreType.MD]: MD_STORE_DETAIL_URL,
  [StoreType.GAMEWEAR]: GAMEWEAR_STORE_DETAIL_URL,
};
